














































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { IOrderData } from '@/api/types'
import OrderTypeOption from './OrderTypeOption.vue'
import ClientIdOption from './ClientIdOption.vue'
import ProductOption from './ProductOption.vue'
import { getClientProducts } from '@/api/clients'
import { ProductModule } from '@/store/modules/products'
import { inspectionTypeAbbrv } from '@/filters'
import { UserModule } from '@/store/modules/user'
import { addComment } from '@/api/orders'

@Component({
  name: 'OrderInformation',
  components: {
    ClientIdOption,
    OrderTypeOption,
    ProductOption
  }
})
export default class extends Vue {
  @Prop({ default: false }) isEdit!: boolean;
  @Prop({ type: Object }) value!: IOrderData;

  private dialogAddComment = false;
  private comment = '';
  private forwardToIntegrationCheck = false;

  get isAdmin() {
    const roles = UserModule.roles
    // console.log(roles)
    return roles.includes('Admin')
  }

  get isValueLinkApi() {
    return this.isValueLinkOrder()
  }

  getClientName(): string {
    const filters = this.$options.filters
    return filters?.clientName(this.value.clientId)
  }

  toggleHistory(): void {
    console.log(' toggle history ')
  }

  async handleClientChange(clientId: number) {
    console.log(' in handleClientChange ' + clientId)
    this.value.productId = null
    this.value.orderType = null
    if (ProductModule.ClientId !== clientId) {
      console.info(`Fetching products for ${clientId} `)
      const response = await getClientProducts(clientId)
      ProductModule.setClient(clientId)
      ProductModule.loadProducts(response.data)
    }
  }

  handleProductChange(product: number) {
    if (product) {
      const selected = ProductModule.cachedProducts.find(
        (item) => item.productId === product
      )
      if (selected) {
        this.value.orderType = selected.orderTypeId
        this.value.productId = selected.productId
        return
      }
    }
    this.value.orderType = null
    this.value.productId = null
  }

  getOrderTypeName() {
    return this.value.orderType
      ? inspectionTypeAbbrv(this.value.orderType || 0)
      : 'Select Order Type'
  }

  isValueLinkOrder() {
    if (this.value !== null && this.value.client !== null && this.value.client.apiName !== null) {
      return this.value.client.apiName === 'ValueLinkApi' || this.value.client.apiName === 'PdxApi'
    }
    return false
  }

  addComment() {
    const request = addComment(this.value.orderId, this.comment, this.forwardToIntegrationCheck)
    request.then(() => {
      this.dialogAddComment = false
      this.comment = ''
      this.forwardToIntegrationCheck = false

      this.$notify({
        title: 'Success',
        message: 'Comment added succesfully.',
        type: 'success',
        duration: 4000
      })
    })
  }
}
